const colors = {
  corePrimary: '#FAB51D',
  corePrimaryLight: '#FDC442',
  corePrimaryLighter: '#FDD67D',
  corePrimaryLighter1: '#FFE9AF',
  corePrimaryLighter2: '#FFF7E0',
  corePrimaryDark: '#F6AA06',
  corePrimaryDarker: '#F0A600',
  corePrimaryDarker1: '#DD8743',
  corePrimaryDarker2: '#C28800',
  coreSecondary: '#010101',

  neutralPrimary: '#FBFBFB',
  neutralPrimary1: '#F0F0F0',
  neutralPrimaryDark: '#EEEEEE',
  neutralPrimaryDark1: '#C8C9CA',
  neutralPrimaryDark2: '#BBBABA',
  neutralPrimaryDark3: '#DDDDDD',
  neutralPrimaryDarker: '#888888',
  neutralSecondary: '#FFFFFF',

  accentPrimary: '#F07100',
  accentSecondary: '#00B000',         // green
  accentSecondaryLight: '#90EE90',
  accentTertiary: '#FF5151',          // red
  accentQuaternary: '#3498DB',        // blue

  transparent: 'transparent',
};

const layers = {
  highest: 5,
  high: 4,
  medium: 3,
  low: 2,
  lowest: 1,
  base: 0
}

const lightTheme = {
  colors,
  layers,
  backgroundColor: colors.neutralPrimary,
  textColor: colors.coreSecondary,
  selectionColor: colors.corePrimaryLighter,
  appPadding: {
    value: 2,
    unit: 'rem'
  },
  animSpeed: '.25s',
  animDelay: '.35s',
  sideNav: {
    openWidth: 22,
    closeWidth: 6,
    animSpeed: '.125s',
    iconColor: colors.coreSecondary,
    backgroundColor: colors.neutralSecondary,
    itemBackground: colors.transparent,
    borderColor: colors.neutralPrimary1,
    hover: {
      itemBackground: colors.neutralPrimary,
      itemColor: colors.corePrimary
    }
  },
  logo: {
    width: 180
  },
  topNav: {},
  card: {
    shadowColor: colors.neutralPrimaryDarker,
    background: colors.neutralPrimary,
    borderColor: colors.neutralPrimaryDark
  },
  form: {
    backgroundTransparent: colors.transparent
  },
  baseInput: {
    borderColor: colors.neutralPrimaryDarker,
    backgroundColor: colors.neutralPrimaryDark,
    placeholder: {
      color: colors.neutralPrimaryDarker
    },
    label: {
      color: colors.neutralPrimaryDarker
    },
    icon: {
      color: colors.coreSecondary,
      inverseColor: colors.corePrimary
    },
    hover: {
      borderColor: colors.neutralPrimaryDarker
    },
    active: {
      borderColor: colors.corePrimaryLight
    },
    focus: {
      borderColor: colors.corePrimaryLight
    },
    disabled: {
      borderColor: colors.neutralPrimary,
      color: colors.neutralPrimaryDarker
    },
    readonly: {
      color: colors.neutralPrimaryDarker
    }
  },
  option: {
    backgroundColor: colors.neutralPrimaryDark,
    borderColor: colors.neutralPrimaryDark1,
    active: {
      color: colors.corePrimaryLight
    }
  },
  button: {
    backgroundColor: colors.neutralSecondary,
    borderColor: colors.neutralPrimaryDarker,
    color: colors.coreSecondary,
    hover: {
      borderColor: colors.neutralPrimaryDarker
    },
    active: {
      borderColor: colors.accentPrimary,
      backgroundColor: colors.corePrimary
    },
    disabled: {
      borderColor: colors.neutralPrimaryDarker,
      color: colors.neutralPrimaryDarker
    }
  },
  primaryButton: {
    backgroundColor: colors.corePrimary,
    borderColor: colors.accentPrimary,
    color: colors.coreSecondary,
    hover: {
      backgroundColor: colors.accentPrimary,
      borderColor: colors.accentPrimary
    },
    active: {
      backgroundColor: colors.accentPrimary,
      borderColor: colors.accentPrimary
    },
    disabled: {
      color: colors.neutralPrimaryDarker,
      borderColor: colors.transparent
    }
  },
  menu: {
    backgroundColor: colors.corePrimary,
    borderColor: colors.neutralPrimaryDarker,
    backgroundColorAlt: colors.coreSecondary
  },
  datepicker: {
    iconColor: colors.accentPrimary,
    header: colors.corePrimary,
    body: '#F2F2F2',
    unavailable: '#CCCCCC'
  },
  modal: {
    backgroundColor: colors.corePrimary
  },
  tooltip: {
    color: colors.corePrimary,
    backgroundColor: '#464646',
    error: {
      backgroundColor: colors.accentTertiary,
      color: colors.coreSecondary
    }
  },
  table: {
    padding: '1rem',
    borderColor: '#e3e8ee',
    backgroundColor: colors.transparent,
    hover: {
      rowBackgroundColor: colors.neutralPrimary
    }
  },
  toast: {
    successColor: colors.accentSecondary,
    infoColor: colors.accentQuaternary,
    warningColor: colors.corePrimaryDark,
    errorColor: colors.accentTertiary
  },
  switch: {
    trueBackgroundColor: colors.accentSecondary,
    falseBackgroundColor: colors.accentTertiary,
    indicatorColor: colors.neutralSecondary,
    disabled: {
      backgroundColor: colors.neutralPrimaryDarker,
      indicatorColor: 'orange'
    },
    hover: {
      trueBackgroundColor: 'darkgreen',
      falseBackgroundColor: 'darkred'
    },
    active: {
      borderColor: colors.accentPrimary
    },
    focus: {
      borderColor: colors.accentPrimary
    }
  },
  progress: {
    activeColor: colors.corePrimary,
    accentColor: colors.corePrimaryLighter,
    completeColor: colors.corePrimaryLighter1,
    inCompleteColor: colors.neutralPrimaryDark,
    inCompleteTextColor: colors.neutralPrimaryDark2
  }
};

// export type Theme = typeof lightTheme;
export default lightTheme;
